var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.eSets.length)?_c('Ccombobox',{attrs:{"id":"kangaroo.sets","show-not-matched":true,"value":_vm.configSet,"values":_vm.eSets,"data-qa":"kangaroo.sets"},on:{"input":_vm.onChange}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }